import { Action } from 'redux'
import { isType } from 'ts-action'
import { IShift, IShiftReducer, IShiftReducerProps } from 'models/Shift'
import {
  UpshifterShiftLoading,
  UpshifterShiftButtonLoading,
  GetUpshifterOpenShift,
  NoActiveUpshifterShift,
  ResetUpshifterActiveShift,
  SetActiveUpshifterShiftScreen,
  CleanUpshifterOpenShift,
  GetUpshifterShiftError,
  UpshifterShiftUpdateApplicants,
  UpshifterShiftFavoriteBusiness,
  UpshifterShiftUnfavoriteBusiness,
} from './actions'

const initialState: IShiftReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: {
    openedShift: {},
    loading: false,
    btnShiftLoading: false,
    isActiveShift: false,
    isShiftScreenActive: false,
  } as IShiftReducerProps,
}

export const shiftReducer = (
  state = initialState,
  action: Action,
): IShiftReducer => {
  if (isType(action, UpshifterShiftLoading)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
      data: { ...state.data },
    }
  }
  if (isType(action, UpshifterShiftButtonLoading)) {
    const { payload } = action
    return {
      ...state,
      data: { ...state.data, btnShiftLoading: payload },
    }
  }
  if (isType(action, GetUpshifterOpenShift)) {
    const { payload } = action
    return {
      ...state,
      error: undefined,
      isFetching: false,
      data: {
        ...state.data,
        openedShift: payload,
        btnShiftLoading: false,
        isActiveShift: true,
        loading: false,
      },
    }
  }
  if (isType(action, NoActiveUpshifterShift)) {
    return {
      ...state,
      data: { ...state.data, isActiveShift: false },
    }
  }
  if (isType(action, ResetUpshifterActiveShift)) {
    return {
      ...state,
      data: { ...state.data, isActiveShift: true, isShiftScreenActive: false },
    }
  }
  if (isType(action, SetActiveUpshifterShiftScreen)) {
    return {
      ...state,
      data: { ...state.data, isActiveShift: true, isShiftScreenActive: true },
    }
  }
  if (isType(action, CleanUpshifterOpenShift)) {
    return {
      ...state,
      data: { ...state.data, openedShift: {} as IShift },
    }
  }
  if (isType(action, GetUpshifterShiftError)) {
    return {
      ...state,
      error: action.payload,
      isFetching: false,
      data: { ...state.data, btnShiftLoading: false },
    }
  }
  if (isType(action, UpshifterShiftUpdateApplicants)) {
    const { data } = state
    const newOpenShift = { ...data.openedShift }
    newOpenShift.applicants = action.payload.applicants
    return {
      ...state,
      data: { ...state.data, openedShift: newOpenShift },
    }
  }
  if (isType(action, UpshifterShiftFavoriteBusiness)) {
    const { data } = state
    const newOpenShift = { ...data.openedShift }
    newOpenShift.favored = true
    newOpenShift.favorite_id = action.payload.id
    return {
      ...state,
      data: { ...state.data, openedShift: newOpenShift },
    }
  }
  if (isType(action, UpshifterShiftUnfavoriteBusiness)) {
    const { data } = state
    const newOpenShift = { ...data.openedShift }
    newOpenShift.favored = false
    newOpenShift.favorite_id = null
    return {
      ...state,
      data: { ...state.data, openedShift: newOpenShift },
    }
  }
  return state
}
